export const name = 'SiteRootAspect'

export const defaultModel = {
    siteRootHidden: false,
    siteRootAriaHidden: false
}
